export default function getDestinationCardPhrase(destinationCardId: number): string {
  return destinationCardId ? `leads to card ${destinationCardId}` : 'not connected';
}
